import { PlaceholderSegment } from '@britishcouncil/react-admin';
import { Centered } from 'components';

export const ChooseRequiredOrganisationContextPlaceholder = () => {
  return (
    <Centered>
      <PlaceholderSegment
        icon="info"
        info
        title="Please select an organisation context required for displaying this page"
      />
    </Centered>
  );
};
